import { Dispatch, SetStateAction } from "react";
import { AssetType } from "../../../shared/types/AssetType";
import { ToolsPanelFilterSelect } from "./ToolsPanelFilterSelect";

type AssetTypeFilterSelectProps = {
    id: string;
    selectedAssetTypeFilter: AssetType | null;
    setSelectedAssetTypeFilter: Dispatch<SetStateAction<AssetType | null>>;
    availableAssetTypes: ReadonlySet<AssetType>;
};

export function AssetTypeFilterSelect({
    id,
    selectedAssetTypeFilter,
    setSelectedAssetTypeFilter,
    availableAssetTypes,
}: AssetTypeFilterSelectProps) {
    const options = [
        { value: '', label: 'All assets' },
        { value: 'Spot', label: 'Spot', disabled: !availableAssetTypes.has(AssetType.Spot) },
        { value: 'Futures', label: 'Futures', disabled: !availableAssetTypes.has(AssetType.Futures) },
        { value: 'Call', label: 'Call', disabled: !availableAssetTypes.has(AssetType.Call) },
        { value: 'Put', label: 'Put', disabled: !availableAssetTypes.has(AssetType.Put) },
    ];

    const handleChange = (value: string): void => {
        setSelectedAssetTypeFilter(value === ''
            ? null
            : AssetType[value as keyof typeof AssetType]);
    };

    return (
        <ToolsPanelFilterSelect
            id={id}
            value={selectedAssetTypeFilter === null ? '' : AssetType[selectedAssetTypeFilter]}
            options={options}
            width={97}
            isFilterApplied={selectedAssetTypeFilter !== null}
            fallbackLabel="All assets"
            onChange={handleChange}
        />
    );
}
